import { COMPONENT_TYPE } from 'common/constants';
import { UNIFORM_PROPS } from 'common/constants/component-props';
import { TimerType } from './constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';

export const timer = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.TIMER> =>
	createModel({
		type: COMPONENT_TYPE.TIMER,
		componentProps: {
			[UNIFORM_PROPS.timerType]: TimerType.num,
			[UNIFORM_PROPS.timerTime]: 30,
			styles: {},
			other: {},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.TIMER>;
